import { bindRequestLogic } from './utils'
import HelpDeskTypes from '../actionTypes/helpDesk'
import { helpDeskAPI } from '../api'

const getHelpDesks = bindRequestLogic({
  clientFunc: helpDeskAPI.getHelpDesks,
  type: HelpDeskTypes.GET_HELP_DESKS_REQUEST,
  successType: HelpDeskTypes.GET_HELP_DESKS_SUCCESS,
  failType: HelpDeskTypes.GET_HELP_DESKS_FAILED,
  isQueryParam: true
})

const addHelpDesk = bindRequestLogic({
  clientFunc: helpDeskAPI.addHelpDesk,
  type: HelpDeskTypes.ADD_HELP_DESK_REQUEST,
  successType: HelpDeskTypes.ADD_HELP_DESK_SUCCESS,
  failType: HelpDeskTypes.ADD_HELP_DESK_FAILED
})

const updateHelpDesk = bindRequestLogic({
  clientFunc: helpDeskAPI.updateHelpDesk,
  type: HelpDeskTypes.UPDATE_HELP_DESK_REQUEST,
  successType: HelpDeskTypes.UPDATE_HELP_DESK_SUCCESS,
  failType: HelpDeskTypes.UPDATE_HELP_DESK_FAILED
})

const getHelpDeskDetail = bindRequestLogic({
  clientFunc: helpDeskAPI.getHelpDesk,
  type: HelpDeskTypes.GET_HELP_DESK_DETAIL_REQUEST,
  successType: HelpDeskTypes.GET_HELP_DESK_DETAIL_SUCCESS,
  failType: HelpDeskTypes.GET_HELP_DESK_DETAIL_FAILED
})
const deleteHelpDesk = bindRequestLogic({
  clientFunc: helpDeskAPI.deleteHelpDesk,
  type: HelpDeskTypes.DELETE_HELP_DESK_REQUEST,
  successType: HelpDeskTypes.DELETE_HELP_DESK_SUCCESS,
  failType: HelpDeskTypes.DELETE_HELP_DESK_FAILED
})

const upsertContentTranslation = bindRequestLogic({
  clientFunc: helpDeskAPI.upsertHelpDeskContentTranslation,
  type: HelpDeskTypes.UPSERT_HELP_DESK_TRANSLATION_REQUEST,
  successType: HelpDeskTypes.UPSERT_HELP_DESK_TRANSLATION_SUCCESS,
  failType: HelpDeskTypes.UPSERT_HELP_DESK_TRANSLATION_FAILED
})

export default [
  getHelpDesks,
  addHelpDesk,
  deleteHelpDesk,
  updateHelpDesk,
  getHelpDeskDetail,
  upsertContentTranslation
]
